module.exports = __webpack_public_path__ + "img/Hero@3x.ddfe012e.png";